/* eslint-disable import/no-cycle */
import React from 'react';

import { useTranslation } from 'react-i18next';

import MainFont from 'ui/typography/mainFont';

import { NotAvailableContent, NotAvailableWrapper } from './style';

const NoDataAvailable = () => {
  const { t } = useTranslation();
  return (
    <NotAvailableWrapper>
      <NotAvailableContent>
        <MainFont type="4" configuration={{ fontSize: 16, lineHeight: '1.5' }}>
          {t('no_data')}
        </MainFont>
      </NotAvailableContent>
    </NotAvailableWrapper>
  );
};

export default NoDataAvailable;
